import React, { useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'

const StyledFormControl = styled(FormControl)`
  margin: 0;
  min-width: 120px;
`
const StyledInputLabel = styled(InputLabel)`
  color: ${({ theme }) => theme.colors.gray[700]};
  font-size: 1.5rem;

  &.Mui-focused {
    color: ${({ theme }) => theme.colors.gray[700]};
  }
`

const StyledSelect = styled(Select)`
  color: ${({ theme }) => theme.colors.gray[900]};
  font-size: 1rem;
`

export const WipBudgetTrendDropdown = ({ onChange }) => {
  const [budgetTrend, setBudgetTrend] = useState('On Target')

  const handleChange = event => {
    if (onChange) onChange(event.target.value)
    setBudgetTrend(event.target.value)
  }

  return (
    <StyledFormControl data-testid="wip.budgetTrend">
      {/* <StyledInputLabel id="wip-select-label">
        <div style={{ display: 'flex' }}>
          <Typography>
            <strong>Budget Trend</strong>
          </Typography>
        </div>
      </StyledInputLabel> */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ marginBottom: 0, marginRight: 20 }}>Budget Trend</h2>
        <StyledSelect
          labelId="wip-select-label"
          id="wip-select"
          data-testid="wip.budgetTrendSelect"
          value={budgetTrend}
          onChange={handleChange}
        >
          <MenuItem value="Adjustment Needed">Adjustment Needed</MenuItem>
          <MenuItem value="On Target">On Target</MenuItem>
        </StyledSelect>
      </div>
    </StyledFormControl>
  )
}

WipBudgetTrendDropdown.propTypes = {
  onChange: PropTypes.func,
}

export default WipBudgetTrendDropdown
